import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CheckboxContainer = styled.div`
  padding: ${Spacing.S12} ${Spacing.S16};
  border: 1px solid ${Color.Grey100};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey50};
`
